import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_BLOCK_WITHOUT_COMMUNITY } from "./apiRoutes";

interface mutateProps {
  zoneId: string;
  communityId: string;
}

const mutateBulkDeletePropertyBlock = async ({ zoneId, communityId }: mutateProps) => {
  return await axiosAuth.delete(`${PROPERTY_BLOCK_WITHOUT_COMMUNITY}/communities/${communityId}/bulk/zones/${zoneId}`);
};

const useBulkDeletePropertyBlockMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateBulkDeletePropertyBlock,
    ...queryParams,
  });

export default useBulkDeletePropertyBlockMutation;
